<template>
  <div class="fund-query">
    <div class="query-title">个性化查询-公允价值表</div>
    <div class="query-container">
      <div class="query-item">
        <label>公司名称</label>
        <a-input class="item-input" />
      </div>
      <div class="query-item">
        <label>基金主体</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in fundList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>

        <label>报表区间</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in tableList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>
      </div>

      <div class="query-item">
        <label>行业领域</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in fieldList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>

        <label>是否已实现</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in realizedList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>
      </div>

      <div class="query-item">
        <label>投资总额</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in sumList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>

        <label>股权比例</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in ownershipRatioList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>
      </div>

      <div class="query-item">
        <label>轮次</label>
        <a-select mode="multiple" size="default" style="flex :1" placeholder="请选择表单">
          <a-select-option v-for="item in roundList" :key="item.name">{{ item.name }}</a-select-option>
        </a-select>
        <div class="submit" @click="queryTable">查询</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOptionLists } from '@/api/finance';
import Event from '@/utils/event';
export default {
  props: {},
  components: {},
  computed: {},
  created() {
    this.getOptionLists();
  },
  data() {
    return {
      allSelect: null,
      company: '',
      fundList: [],
      selectedFund: null,
      tableList: [],
      selectedTable: null,
      fieldList: [],
      selectedField: null,
      realizedList: [],
      selectedRealized: null,
      sumList: [],
      selectedSum: null,
      ownershipRatioList: [],
      selectedOwnershipRatio: null,
      roundList: [],
      selectedRound: null
    };
  },
  methods: {
    getOptionLists() {
      getOptionLists().then(res => {
        const data = res.data;
        this.fundList = data.fundList;
        this.selectedFund = this.fundList[0];
        this.tableList = data.tableList;
        this.selectedTable = this.tableList[0];
        this.fieldList = data.fieldList;
        this.selectedField = this.fieldList[0];
        this.realizedList = data.realizedList;
        this.selectedRealized = this.realizedList[0];
        this.sumList = data.sumList;
        this.selectedSum = this.sumList[0];
        this.ownershipRatioList = data.ownershipRatioList;
        this.selectedOwnershipRatio = this.ownershipRatioList[0];
        this.roundList = data.roundList;
        this.selectedRound = this.roundList[0];
      });
    },
    queryTable() {
      Event.$emit('queryTable', {
        finished: true,
        unfinished: false
      });
    }
  }
};
</script>
<style scoped lang="less">
.fund-query {
  .query-title {
    font-size: 24px;
    font-weight: bold;
  }
  .query-container {
    width: 60%;
    margin-bottom: 20px;
    .query-item {
      position: relative;
      margin-top: 20px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      label {
        // min-width: fit-content;
        min-width: 60px;
        margin-right: 10px;
        &:nth-of-type(2) {
          margin-left: 40px;
        }
      }
      .submit {
        cursor: pointer;
        right: 0;
        margin-left: 40%;
        background: #1890ff;
        color: #ffffff;
        padding: 4px 10px;
      }
    }
  }
}
</style>
